/**
 * Quick-filter status chip values for the Manage Returns list (query param `status` / store field
 * `filter_status`). Lives in a dependency-free module so helpers and stores can import it without
 * circular imports (e.g. `rma-paged-list-store` must not be loaded before this enum is defined).
 * Wire values must stay aligned with the rms-api `RMA_STATUS_FILTER` allowlist.
 */

export enum RMA_QUICK_FILTERS {
    ALL = "all",
    OPEN = "open",
    PENDING = "pending",
    APPROVED = "approved",
    IN_TRANSIT = "in-transit",
    RECEIVED = "received",
    DONE = "done",
    REJECTED = "rejected",
    CANCELED = "canceled",
    SHIPMENT_REJECTED = "shipment_rejected",
    REQUIRE_ATTENTION = "require-attention",
    PENDING_MANAGER_APPROVAL_ONLY = "pending-manager-approval-only",
    PENDING_APPROVAL_ONLY = "pending-approval-only",
}
